







import { CreateElement } from "vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import { IAffiliatePendingCommission } from "@/models/affiliate";
import { mapState } from "vuex";
import { DataModules } from "@/store/modules/data";

@Component({
  computed: {
    ...mapState({
      isAwaitingPayment(state, getters) {
        return getters[
          `data/${DataModules.AFFILIATES_COMMISSIONS}/isAwaitingPayment`
        ](this.commission);
      },
      isCancelled(state, getters) {
        return getters[
          `data/${DataModules.AFFILIATES_COMMISSIONS}/isCancelled`
        ](this.commission);
      },
      isOnHold(state, getters) {
        return getters[`data/${DataModules.AFFILIATES_COMMISSIONS}/isOnHold`](
          this.commission
        );
      },
      isPendingApproval(state, getters) {
        return getters[
          `data/${DataModules.AFFILIATES_COMMISSIONS}/isPendingApproval`
        ](this.commission);
      },
      isRejected(state, getters) {
        return getters[`data/${DataModules.AFFILIATES_COMMISSIONS}/isRejected`](
          this.commission
        );
      }
    })
  }
})
export default class CommissionSummary extends Vue {
  // Props

  @Prop({ required: true })
  public commission!: IAffiliatePendingCommission;

  @Prop({ default: "p" })
  public tag!: string;

  // Computed

  public get dateTimeProps() {
    return {
      formatFunction: "calendar",
      formatFunctionParams: {
        sameDay: this.$t("_datetime.calendar.sameDay"),
        lastDay: this.$t("_datetime.calendar.lastDay"),
        nextDay: this.$t("_datetime.calendar.nextDay"),
        nextWeek: "MMM Do",
        lastWeek: "MMM Do",
        sameElse: "MMM Do"
      }
    };
  }

  public readonly isAwaitingPayment!: boolean;
  public readonly isCancelled!: boolean;
  public readonly isOnHold!: boolean;
  public readonly isPendingApproval!: boolean;
  public readonly isRejected!: boolean;

  public get summary() {
    // Rejected
    if (this.isRejected)
      return {
        type: "is-danger",
        icon: "times-circle",
        i18n: {
          render: (h: CreateElement) =>
            h(
              "i18ntc",
              {
                props: {
                  path: "_sentence.affiliate.commission_rejected",
                  count: !this.commission.reject_reason ? 1 : 2
                }
              },
              [
                h("datetime", {
                  slot: "date",
                  props: {
                    ...this.dateTimeProps,
                    datetime: this.commission.rejected_at
                  }
                }),
                h("template", { slot: "reason" }, [
                  this.commission.reject_reason
                ])
              ]
            )
        }
      };
    // Awaiting payment
    if (this.isAwaitingPayment)
      return {
        type: "is-warning",
        icon: "exclamation-circle",
        i18n: {
          render: (h: CreateElement) =>
            h("i18n", {
              props: {
                path: "_sentence.affiliate.commission_awaiting_invoice_payment"
              }
            })
        }
      };
    // Pending approval
    if (this.isPendingApproval)
      return {
        type: "is-warning",
        icon: "clock",
        i18n: {
          render: (h: CreateElement) =>
            h(
              "i18n",
              {
                props: {
                  path: "_sentence.affiliate.commission_approval_expected"
                }
              },
              [
                h("datetime", {
                  slot: "date",
                  key: `${this.commission.payout_calculated_date}`,
                  props: {
                    ...this.dateTimeProps,
                    datetime: this.commission.payout_calculated_date
                  }
                })
              ]
            )
        }
      };
    // On hold
    if (this.isOnHold)
      return {
        type: "is-grey",
        icon: "pause-circle",
        i18n: {
          render: (h: CreateElement) =>
            h("i18n", {
              props: {
                path: "_sentence.affiliate.commission_on_hold"
              }
            })
        }
      };
    // Cancelled
    if (this.isCancelled)
      return {
        type: "is-danger",
        icon: "times-circle",
        i18n: {
          render: (h: CreateElement) =>
            h("i18n", {
              props: {
                path: "_sentence.affiliate.commission_cancelled"
              }
            })
        }
      };
    // Approved
    return {
      type: "is-success",
      icon: "check-circle",
      i18n: {
        render: (h: CreateElement) =>
          h(
            "i18n",
            {
              props: {
                path: "_sentence.affiliate.commission_approved"
              }
            },
            [
              h("datetime", {
                slot: "date",
                key: `${this.commission.approved_at}`,
                props: {
                  ...this.dateTimeProps,
                  datetime: this.commission.approved_at
                }
              })
            ]
          )
      }
    };
  }
}
